import React, { useEffect, useState, useContext } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import EnterpriseForm from './EnterpriseForm'
import GetStarted from './GetStarted'
import Wait from '@react/react-spectrum/Wait'

export default function Signup (props) {
    const { referrer } = props

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [referrer])

    if (!referrer) {
        return <div className="adobe-easybake-main-sub-pane">
            <div className="adobe-easybake-modal-loading-bg-white">
                <Wait size="L" />
            </div>
        </div>
    } else {
        if (referrer === "contactsales") {
            return <EnterpriseForm />
        } else {
            return <GetStarted />
        }
    }
}
